import React from 'react'
import { Subscribe } from 'unstated'
import CalendarStore from '../Store/CalendarStore'
import date from 'date-and-time'

const DayMarkers = () => (
  <Subscribe to={[CalendarStore]}>
    {({ state }) => (
      <div className='dayMarkers'>
        <div className='timeMarker' />
        {state.currentWeek.map((day, i) => (
          <div
            className={
              'day dayMarker' +
              (day.toLocaleDateString() === new Date().toLocaleDateString()
                ? ' today'
                : '')
            }
            key={'dayMarker' + i}
          >
            <p>{date.format(day, 'dddd')}</p>
            {state.mode !== 'becomeTeacher' && (
              <p>{date.format(day, 'M/DD')}</p>
            )}
          </div>
        ))}
      </div>
    )}
  </Subscribe>
)

export default DayMarkers
